export class AutoSampleResult {

  constructor(
    public applicationIds?: number[],
    public sampledAbstractCount?: number,
    public highPriDisagreeSampleCount?: number,
    public lowPriDisagreeSampleCount?: number,
    public fullAgreeSampleCount?: number,
  ) { }
}
